// extracted by mini-css-extract-plugin
export default {"create-menu":"create-element_create-menu__43PAj","create-menu__anchor":"create-element_create-menu__anchor__ykYgB","create-menu--open":"create-element_create-menu--open__Z2o9S"};